import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Aligner is a utility used across multiple components to apply
 * negative margin based on the component padding to align its text content
 * visually with the rest of the page
 *
 * It relies on using a data-rs-aligner-target attribute in other components and works based
 * on the --rs-p, --rs-p-v and --rs-p-h css variables
 */
import { classNames } from "../../../utilities/props.js";
import s from "./Aligner.module.css";
const Aligner = (props) => {
    const { side: passedSide = "all", children, className, attributes } = props;
    const sides = typeof passedSide === "string" ? [passedSide] : passedSide;
    const rootClassNames = classNames(s.root, sides.map((side) => s[`--side-${side}`]), className);
    return (_jsx("div", { ...attributes, className: rootClassNames, children: children }));
};
Aligner.displayName = "Aligner";
export default Aligner;
